/* ==========================================================================
   MYKONOS — theme.js  (vanilla, no dependencies)
   ========================================================================== */
(function () {
  'use strict';
  var M = window.Mykonos || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var body = document.body;

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var fmt = M.moneyFormat || '${{amount}}';
    var value = (cents / 100);
    function num(n, dec, ts, ds) {
      dec = dec == null ? 2 : dec; ts = ts == null ? '.' : ts; ds = ds == null ? ',' : ds;
      var s = Math.abs(n).toFixed(dec), parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts.join(parts[1] ? ds : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m0, key) {
      switch (key) {
        case 'amount': return num(value, 2, '.', ',');
        case 'amount_no_decimals': return num(value, 0, '.', ',');
        case 'amount_with_comma_separator': return num(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(value, 0, '.', ',');
        case 'amount_with_space_separator': return num(value, 2, ' ', ',');
        default: return num(value, 2, '.', ',');
      }
    });
  }

  /* ---------- Toast ---------- */
  function toast(msg, icon) {
    var host = $('[data-toasts]'); if (!host) return;
    var t = document.createElement('div'); t.className = 'toast';
    t.innerHTML = (icon || '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12.5 4.2 4.2L19 7"/></svg>') + '<span>' + msg + '</span>';
    host.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    setTimeout(function () { t.classList.remove('is-in'); setTimeout(function () { t.remove(); }, 350); }, 3200);
  }

  /* ---------- Overlay / drawers ---------- */
  var overlay = $('[data-overlay]');
  function openLayer(el) {
    if (!el) return;
    el.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    body.classList.add('no-scroll');
    el.setAttribute('aria-hidden', 'false');
    var f = el.querySelector('input,button,a,select,textarea'); if (f) try { f.focus(); } catch (e) {}
  }
  function closeLayers() {
    $$('.drawer.is-open, .sizechart.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    if (overlay) overlay.classList.remove('is-open');
    var sp = $('[data-search-panel]'); if (sp) sp.setAttribute('hidden', '');
    body.classList.remove('no-scroll');
  }
  if (overlay) overlay.addEventListener('click', closeLayers);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLayers(); });

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-cart],[data-open-menu],[data-open-filters],[data-open-search],[data-open-sizechart],[data-open-promo],[data-close-cart],[data-close-menu],[data-close-filters],[data-close-search],[data-close-sizechart],[data-close-promo]');
    if (!t) return;
    if (t.hasAttribute('data-open-cart')) { e.preventDefault(); refreshCart().then(function(){ openLayer($('[data-cart-drawer]')); }); }
    else if (t.hasAttribute('data-open-menu')) { openLayer($('[data-menu-drawer]')); }
    else if (t.hasAttribute('data-open-filters')) { openLayer($('[data-filter-drawer]')); }
    else if (t.hasAttribute('data-open-sizechart')) { openLayer($('[data-sizechart]')); }
    else if (t.hasAttribute('data-open-promo')) { openLayer($('[data-promo-drawer]')); }
    else if (t.hasAttribute('data-open-search')) {
      var sp = $('[data-search-panel]'); if (sp) { sp.removeAttribute('hidden'); if (overlay) overlay.classList.add('is-open'); var i = $('[data-search-input]'); if (i) i.focus(); }
    }
    else { closeLayers(); }
  });

  /* ---------- Sticky header ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 12); };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Scroll reveal ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    $$('[data-reveal]').forEach(function (el) { io.observe(el); });
    window.__mykRevealObserver = io;
  } else {
    $$('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ==========================================================
     CART (AJAX)
     ========================================================== */
  function setCartCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n; el.hidden = n < 1; el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
    });
    $$('[data-cart-count-text]').forEach(function (el) { el.textContent = '(' + n + ')'; });
  }

  function refreshCart() {
    return fetch(M.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCartCount(cart.item_count);
        return fetch('?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (html) {
          var body = $('[data-cart-body]');
          if (body) {
            var tmp = document.createElement('div'); tmp.innerHTML = html;
            var fresh = tmp.querySelector('.shopify-section') ? tmp.querySelector('.shopify-section').innerHTML : html;
            body.innerHTML = fresh;
            animateFreebar(body);
          }
          return cart;
        });
      });
  }

  function animateFreebar(scope) {
    var fb = $('[data-freebar-fill]', scope) || $('.freebar__fill', scope || document);
    if (fb) { var w = fb.style.width; fb.style.width = '0'; requestAnimationFrame(function () { fb.style.width = w; }); }
  }

  function addToCart(id, qty, btn) {
    qty = qty || 1;
    if (btn) btn.classList.add('is-loading');
    return fetch(M.routes.cart_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: qty }] })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.data.description || res.data.message || 'Erro ao adicionar', errIcon()); if (btn) btn.classList.remove('is-loading'); return; }
        var title = (res.data.items && res.data.items[0] && res.data.items[0].product_title) || res.data.product_title || '';
        if (btn) {
          btn.classList.remove('is-loading'); btn.classList.add('is-done');
          setTimeout(function () { btn.classList.remove('is-done'); }, 1600);
        }
        toast((M.strings.added || 'Adicionado') + (title ? ' · ' + title : ''));
        return refreshCart().then(function () { openLayer($('[data-cart-drawer]')); });
      }).catch(function () { if (btn) btn.classList.remove('is-loading'); toast('Erro de conexão', errIcon()); });
  }
  function errIcon() { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M12 8v5M12 16v.5M12 3l9 16H3z"/></svg>'; }

  function changeLine(key, qty) {
    return fetch(M.routes.cart_change, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      setCartCount(cart.item_count);
      // refresh both drawer and cart page
      var onCartPage = $('[data-cart-page]');
      if (onCartPage) { window.location.reload(); return cart; }
      return refreshCart();
    });
  }

  /* Quick add (cards / shop the look) */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-quick-add]');
    if (q) { e.preventDefault(); var id = q.getAttribute('data-quick-add'); if (id) addToCart(id, 1, q); }
  });

  /* ---------- Quick-shop popover on product cards ---------- */
  function qsCloseAll(except) { $$('[data-qs]').forEach(function (q) { if (q !== except) q.hidden = true; }); }
  function qsSelections(qs) {
    var n = 0; $$('input[data-opt]', qs).forEach(function (r) { n = Math.max(n, parseInt(r.getAttribute('data-opt'), 10) + 1); });
    var o = []; for (var i = 0; i < n; i++) o[i] = undefined;
    $$('input[data-opt]:checked', qs).forEach(function (r) { o[parseInt(r.getAttribute('data-opt'), 10)] = r.value; });
    return o;
  }
  function qsVariant(qs) {
    var o = qsSelections(qs); if (o.indexOf(undefined) !== -1) return null;
    var vs = qs.__variants || [];
    return vs.find(function (v) { for (var i = 0; i < o.length; i++) { if (String(v['option' + (i + 1)]) !== String(o[i])) return false; } return true; }) || null;
  }
  function qsUpdate(qs) {
    var add = qs.querySelector('[data-qs-add]'); if (!add) return;
    var v = qsVariant(qs);
    if (!v) { add.disabled = true; add.textContent = M.strings.choose_size || 'Selecione'; }
    else if (!v.available) { add.disabled = true; add.textContent = M.strings.soldout || 'Esgotado'; }
    else { add.disabled = false; add.textContent = (M.strings.add || 'Adicionar à sacola'); }
  }
  function qsInit(qs) {
    if (!qs.__init) {
      qs.__init = true;
      try { qs.__variants = JSON.parse(qs.querySelector('[data-qs-variants]').textContent); } catch (e) { qs.__variants = []; }
      qs.addEventListener('change', function (e) { if (e.target.matches('input[data-opt]')) qsUpdate(qs); });
    }
    qsUpdate(qs);
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-qs-open]');
    if (open) {
      e.preventDefault();
      var qs = open.closest('.pcard').querySelector('[data-qs]');
      qsCloseAll(qs); qs.hidden = !qs.hidden; if (!qs.hidden) qsInit(qs);
      return;
    }
    var close = e.target.closest('[data-qs-close]');
    if (close) { close.closest('[data-qs]').hidden = true; return; }
    var add = e.target.closest('[data-qs-add]');
    if (add) {
      var panel = add.closest('[data-qs]'); var v = qsVariant(panel);
      if (!v) { qsUpdate(panel); toast(M.strings.choose_size || 'Selecione uma opção', errIcon()); return; }
      if (!v.available) { toast(M.strings.soldout || 'Esgotado', errIcon()); return; }
      addToCart(v.id, 1, add).then(function () { panel.hidden = true; });
      return;
    }
    if (!e.target.closest('[data-qs]') && !e.target.closest('[data-qs-open]')) qsCloseAll();
  });

  /* Qty steppers + remove (event delegation, works after re-render) */
  document.addEventListener('click', function (e) {
    var up = e.target.closest('[data-qty-up]'), down = e.target.closest('[data-qty-down]'), rem = e.target.closest('[data-remove]');
    if (up || down) {
      var wrap = (up || down).closest('[data-qty]') || (up || down).closest('.qty');
      var input = wrap && wrap.querySelector('[data-qty-input]');
      if (!input) return;
      var v = parseInt(input.value, 10) || 1; v = up ? v + 1 : Math.max(1, v - 1);
      input.value = v;
      var line = (up || down).closest('[data-line-item]');
      if (line) changeLine(line.getAttribute('data-key'), v);
    }
    if (rem) {
      var li = rem.closest('[data-line-item]');
      if (li) { li.style.opacity = '.4'; li.style.pointerEvents = 'none'; changeLine(li.getAttribute('data-key'), 0); }
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (input) {
      var line = input.closest('[data-line-item]');
      var v = Math.max(1, parseInt(input.value, 10) || 1); input.value = v;
      if (line) changeLine(line.getAttribute('data-key'), v);
    }
    // cart note
    var note = e.target.closest('[data-cart-note]');
    if (note) { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) }); }
  });

  /* ==========================================================
     HERO SLIDESHOW
     ========================================================== */
  $$('[data-hero]').forEach(function (hero) {
    var slides = $$('[data-hero-slide]', hero); if (slides.length < 2) { return; }
    var dots = $$('[data-hero-dot]', hero); var cur = 0, timer = null;
    var auto = hero.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(hero.getAttribute('data-interval'), 10) || 6000;
    function go(n) {
      cur = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        if (i === cur) { s.hidden = false; requestAnimationFrame(function () { s.classList.add('is-active'); }); }
        else { s.classList.remove('is-active'); setTimeout(function () { if (parseInt(s.getAttribute('data-index'),10) !== cur) s.hidden = true; }, 600); }
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === cur); });
    }
    function next() { go(cur + 1); } function prev() { go(cur - 1); }
    function play() { if (auto) { stop(); timer = setInterval(next, interval); } }
    function stop() { if (timer) clearInterval(timer); }
    var nb = $('[data-hero-next]', hero), pb = $('[data-hero-prev]', hero);
    if (nb) nb.addEventListener('click', function () { next(); play(); });
    if (pb) pb.addEventListener('click', function () { prev(); play(); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); play(); }); });
    hero.addEventListener('mouseenter', stop); hero.addEventListener('mouseleave', play);
    // swipe
    var x0 = null;
    hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); play(); } x0 = null; });
    go(0); play();
  });

  /* ==========================================================
     CAROUSEL (product rows)
     ========================================================== */
  $$('[data-caro]').forEach(function (caro) {
    var track = $('[data-caro-track]', caro);
    var head = caro.closest('.section') ? caro.closest('.section').querySelector('.rowhead') : null;
    var prev = head ? head.querySelector('[data-caro-prev]') : caro.parentNode.querySelector('[data-caro-prev]');
    var next = head ? head.querySelector('[data-caro-next]') : caro.parentNode.querySelector('[data-caro-next]');
    if (!track) return;
    function amt() { var first = track.children[0]; return first ? first.getBoundingClientRect().width + 24 : 300; }
    function upd() {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft < 8;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -amt() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: amt() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', upd, { passive: true }); upd();
  });

  /* ==========================================================
     PRODUCT PAGE
     ========================================================== */
  (function initProduct() {
    var section = $('[data-product-section]'); if (!section) return;

    /* Gallery */
    var thumbs = $$('[data-thumb]', section), slides = $$('[data-slide]', section);
    function showSlide(i) {
      slides.forEach(function (s) { s.hidden = parseInt(s.getAttribute('data-slide'), 10) !== i; });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', parseInt(t.getAttribute('data-thumb'), 10) === i); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showSlide(parseInt(t.getAttribute('data-thumb'), 10)); }); });

    /* Zoom on hover (desktop) */
    $$('[data-zoom]', section).forEach(function (z) {
      var img = z.querySelector('[data-zoom-img]'); if (!img) return;
      z.addEventListener('mousemove', function (e) {
        if (window.matchMedia('(hover:none)').matches) return;
        var r = z.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        img.style.transform = 'scale(2)';
      });
      z.addEventListener('mouseleave', function () { img.style.transform = ''; });
    });

    /* Variant selection */
    var form = $('[data-product-form]', section);
    var variantsEl = $('[data-variants]', section);
    var variants = [];
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) {}
    var idInput = $('[data-variant-id]', section);
    var atc = $('[data-atc]', section), atcLabel = $('[data-atc-label]', section);
    var priceEl = $('[data-price]', section), compareEl = $('[data-compare]', section), saveEl = $('[data-save]', section);
    var instEl = $('[data-installments]', section);
    var stickyPrice = $('[data-sticky-price]');

    // number of option groups on the page
    var optCount = 0;
    $$('input[type=radio][data-opt]', form).forEach(function (r) {
      optCount = Math.max(optCount, parseInt(r.getAttribute('data-opt'), 10) + 1);
    });
    function selectedOptions() {
      var opts = [];
      for (var i = 0; i < optCount; i++) opts[i] = undefined; // dense
      $$('input[type=radio][data-opt]:checked', form).forEach(function (r) {
        opts[parseInt(r.getAttribute('data-opt'), 10)] = r.value;
      });
      return opts;
    }
    function findVariant(opts) {
      if (opts.indexOf(undefined) !== -1) return null; // incomplete selection
      return variants.find(function (v) {
        for (var i = 0; i < opts.length; i++) {
          if (String(v['option' + (i + 1)]) !== String(opts[i])) return false;
        }
        return true;
      }) || null;
    }
    function updateUI() {
      var opts = selectedOptions();
      // reflect selected value label
      $$('[data-option-value]', section).forEach(function (span) {
        var i = parseInt(span.getAttribute('data-option-value'), 10); if (opts[i]) span.textContent = opts[i];
      });
      // active swatch styling
      $$('.swatch', section).forEach(function (sw) { var inp = sw.querySelector('input'); sw.classList.toggle('is-active', inp && inp.checked); });

      // mark sold-out sizes visually (never blocks selection)
      markSoldOut(opts);

      var v = findVariant(opts);
      if (!v) { if (atc) { atc.disabled = true; if (atcLabel) atcLabel.textContent = M.strings.choose_size || 'Selecione uma opção'; } return; }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (priceEl) priceEl.classList.toggle('on-sale', onSale);
      if (compareEl) { compareEl.style.display = onSale ? '' : 'none'; if (onSale) compareEl.textContent = formatMoney(v.compare_at_price); }
      if (saveEl) { if (onSale) { saveEl.style.display = ''; saveEl.textContent = '-' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%'; } else saveEl.style.display = 'none'; }
      if (instEl) { var count = parseInt(instEl.getAttribute('data-installments-count'), 10) || 6; instEl.textContent = 'ou ' + count + 'x de ' + formatMoney(Math.round(v.price / count)) + ' sem juros'; }
      if (atc) {
        atc.disabled = !v.available;
        if (atcLabel) atcLabel.textContent = v.available ? (atc.getAttribute('data-add-label') || 'Adicionar à sacola') : (M.strings.soldout || 'Esgotado');
      }
      // update image to variant featured
      if (v.featured_media && typeof v.featured_media.position === 'number') { showSlide(v.featured_media.position - 1); }
      // update URL
      if (history.replaceState && v.id) {
        var u = new URL(window.location); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
      }
    }

    // Visually flag sold-out sizes for the currently selected other options.
    // Does NOT disable them — the customer can always pick any size; the ATC
    // button reflects availability after selection.
    function markSoldOut(opts) {
      var sizeInputs = $$('[data-sizes] input[type=radio]', section);
      if (!sizeInputs.length) return;
      var sizeIdx = parseInt(sizeInputs[0].getAttribute('data-opt'), 10);
      sizeInputs.forEach(function (inp) {
        var test = opts.slice(); test[sizeIdx] = inp.value;
        var match = variants.find(function (v) {
          for (var i = 0; i < test.length; i++) {
            if (i === sizeIdx) { if (String(v['option' + (i + 1)]) !== String(test[i])) return false; }
            else if (test[i] != null && String(v['option' + (i + 1)]) !== String(test[i])) return false;
          }
          return true;
        });
        var soldOut = match ? !match.available : false; // unknown => not sold out
        inp.disabled = false; // never block selection
        var box = inp.nextElementSibling;
        if (box) box.classList.toggle('is-soldout', soldOut);
      });
    }

    if (form) {
      form.addEventListener('change', function (e) { if (e.target.matches('input[type=radio][data-opt]')) updateUI(); });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var opts = selectedOptions(); var v = findVariant(opts);
        if (!v || !v.available) { toast(M.strings.choose_size || 'Selecione um tamanho', errIcon()); pulseSizes(); return; }
        var qtyInput = $('[data-qty-input]', form); var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        addToCart(v.id, qty, atc);
      });
    }
    function pulseSizes() {
      var sg = $('[data-sizes]', section) || $('[data-generic-opt]', section);
      if (sg) { sg.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }], { duration: 320 }); }
    }
    updateUI();

    /* Sticky ATC */
    var sticky = $('[data-sticky-atc]'), stickyBtn = $('[data-sticky-add]');
    if (sticky) {
      var atcRow = $('.pdp-actions', section);
      if ('IntersectionObserver' in window && atcRow) {
        new IntersectionObserver(function (ents) {
          ents.forEach(function (en) { sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
        }, { threshold: 0 }).observe(atcRow);
      }
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        var opts = selectedOptions(); var v = findVariant(opts);
        if (!v) { window.scrollTo({ top: (atcRow.getBoundingClientRect().top + window.scrollY - 120), behavior: 'smooth' }); pulseSizes(); return; }
        if (!v.available) { toast(M.strings.soldout || 'Esgotado', errIcon()); return; }
        addToCart(v.id, 1, stickyBtn);
      });
    }

    /* Accordion */
    $$('[data-accordion] .acc__head', section).forEach(function (h) {
      h.addEventListener('click', function () {
        var item = h.closest('.acc__item'); var open = item.classList.toggle('is-open');
        h.setAttribute('aria-expanded', open);
      });
    });
  })();

  /* Accordion (generic, outside product) */
  $$('.acc__head').forEach(function (h) {
    if (h.closest('[data-product-section]')) return;
    h.addEventListener('click', function () { var i = h.closest('.acc__item'); if (i) i.classList.toggle('is-open'); });
  });

  /* ==========================================================
     INTERACTIVE SIZE CHART
     ========================================================== */
  (function initSizeChart() {
    var sc = $('[data-sizechart]'); if (!sc) return;
    var data;
    try { data = JSON.parse($('[data-sizechart-data]', sc).textContent); } catch (e) { return; }
    var sizes = data.sizes || [];
    var unit = 'cm';
    var CM_IN = 0.3937;
    function conv(v) { return unit === 'cm' ? Math.round(v) : Math.round(v * CM_IN); }
    function suffix() { return unit === 'cm' ? 'cm' : 'pol'; }

    var tbody = $('[data-size-tbody]', sc);
    function renderTable(recName) {
      tbody.innerHTML = sizes.map(function (s) {
        var rec = s.name === recName;
        return '<tr class="' + (rec ? 'is-rec' : '') + '"><td>' + s.name + (rec ? ' ★' : '') + '</td>' +
          '<td>' + conv(s.bust[0]) + '–' + conv(s.bust[1]) + '</td>' +
          '<td>' + conv(s.waist[0]) + '–' + conv(s.waist[1]) + '</td>' +
          '<td>' + conv(s.hip[0]) + '–' + conv(s.hip[1]) + '</td>' +
          '<td>' + (s.br || '—') + '</td></tr>';
      }).join('');
    }

    var fit = 'ideal';
    function recommend() {
      var bust = parseInt($('[data-measure=bust]', sc).value, 10);
      var waist = parseInt($('[data-measure=waist]', sc).value, 10);
      var hip = parseInt($('[data-measure=hip]', sc).value, 10);
      // score each size by how well the 3 measurements fit inside the range midpoints
      var best = null, bestScore = Infinity;
      sizes.forEach(function (s) {
        var score = 0;
        [['bust', bust], ['waist', waist], ['hip', hip]].forEach(function (p) {
          var range = s[p[0]], mid = (range[0] + range[1]) / 2;
          var val = p[1];
          if (val < range[0]) score += (range[0] - val) * 1.4; // too big for size -> penalize going smaller
          else if (val > range[1]) score += (val - range[1]) * 1.6;
          else score += Math.abs(val - mid) * 0.3;
        });
        if (score < bestScore) { bestScore = score; best = s; }
      });
      // fit adjustment
      if (best) {
        var idx = sizes.indexOf(best);
        if (fit === 'solto' && idx < sizes.length - 1) best = sizes[idx + 1];
        if (fit === 'justo' && idx > 0 && bestScore > 2) best = sizes[idx - 1];
      }
      var resEl = $('[data-finder-result]', sc), recEl = $('[data-rec]', sc), recText = $('[data-rec-text]', sc);
      var applyBtn = $('[data-apply-size]', sc);
      if (best) {
        resEl.classList.remove('is-empty');
        recEl.textContent = best.name;
        recText.innerHTML = 'Tamanho recomendado para você. <br><span style="color:var(--c-muted);font-size:var(--fs-xs)">Equivalente BR ' + (best.br || '') + '</span>';
        renderTable(best.name);
        if (applyBtn) { applyBtn.hidden = false; applyBtn.setAttribute('data-size-name', best.name); var sn = $('[data-apply-size-name]', applyBtn); if (sn) sn.textContent = best.name; }
      }
    }

    // range outputs
    $$('[data-measure]', sc).forEach(function (r) {
      r.addEventListener('input', function () {
        var out = $('[data-out=' + r.getAttribute('data-measure') + ']', sc);
        if (out) out.textContent = conv(parseInt(r.value, 10));
        recommend();
      });
    });

    // unit toggle
    $$('[data-unit-toggle] button', sc).forEach(function (b) {
      b.addEventListener('click', function () {
        unit = b.getAttribute('data-unit');
        $$('[data-unit-toggle] button', sc).forEach(function (x) { x.classList.toggle('is-active', x === b); });
        $$('[data-unit-suffix]', sc).forEach(function (s) { s.textContent = suffix(); });
        $$('[data-mlabel]', sc).forEach(function (s) { s.textContent = '(' + suffix() + ')'; });
        $$('[data-measure]', sc).forEach(function (r) { var out = $('[data-out=' + r.getAttribute('data-measure') + ']', sc); if (out) out.textContent = conv(parseInt(r.value, 10)); });
        recommend();
      });
    });

    // fit toggle
    $$('[data-fit-toggle] button', sc).forEach(function (b) {
      b.addEventListener('click', function () {
        fit = b.getAttribute('data-fit');
        $$('[data-fit-toggle] button', sc).forEach(function (x) { x.classList.toggle('is-active', x === b); });
        recommend();
      });
    });

    // apply recommended size to product form
    var applyBtn = $('[data-apply-size]', sc);
    if (applyBtn) applyBtn.addEventListener('click', function () {
      var name = applyBtn.getAttribute('data-size-name');
      var input = $$('[data-sizes] input[type=radio]').filter(function (i) { return i.value === name; })[0];
      if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); toast('Tamanho ' + name + ' selecionado'); closeLayers(); }
      else { toast('Tamanho ' + name + ' não encontrado nesta peça'); }
    });

    renderTable(null); recommend();
  })();

  /* ==========================================================
     COLLECTION: sort + grid toggle + facets
     ========================================================== */
  (function initCollection() {
    var sort = $('[data-sort]');
    if (sort) sort.addEventListener('change', function () {
      var u = new URL(window.location); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); window.location = u.toString();
    });
    var toggle = $('[data-grid-toggle]');
    if (toggle) {
      var grid = $('[data-product-grid]');
      $$('button', toggle).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('button', toggle).forEach(function (x) { x.classList.remove('is-active'); }); b.classList.add('is-active');
          var cols = b.getAttribute('data-cols');
          if (grid) { grid.classList.remove('cols-2', 'cols-4'); grid.classList.add('cols-' + cols); }
        });
      });
    }
    // auto-submit facet form on change
    $$('[data-facet-form]').forEach(function (f) {
      f.addEventListener('change', function () {
        var params = new URLSearchParams(new FormData(f));
        var u = new URL(window.location); u.search = '';
        params.forEach(function (val, key) { if (val) u.searchParams.append(key, val); });
        window.location = u.toString();
      });
    });
  })();

  /* ==========================================================
     PREDICTIVE SEARCH (lightweight)
     ========================================================== */
  (function initSearch() {
    var input = $('[data-search-input]'); var out = $('[data-search-suggest]');
    if (!input || !out) return;
    var t;
    input.addEventListener('input', function () {
      clearTimeout(t); var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      t = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var items = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (!items.length) { out.innerHTML = '<p class="text-muted" style="padding:.6rem 0">Nenhum resultado para "' + q + '"</p>'; return; }
            out.innerHTML = '<div style="display:grid;gap:.4rem;padding:.6rem 0">' + items.map(function (p) {
              return '<a href="' + p.url + '" style="display:flex;gap:.8rem;align-items:center;padding:.4rem;border-radius:var(--r-md)">' +
                (p.image ? '<img src="' + p.image + '" width="44" height="58" style="object-fit:cover;border-radius:4px" alt="">' : '') +
                '<span><span style="font-weight:500">' + p.title + '</span><br><span class="text-muted" style="font-size:.85rem">' + (p.price || '') + '</span></span></a>';
            }).join('') + '</div>';
          });
      }, 220);
    });
  })();

  /* ==========================================================
     WISHLIST (localStorage)
     ========================================================== */
  /* Footer accordion (mobile only) */
  document.addEventListener('click', function (e) {
    var h = e.target.closest('[data-footer-toggle]');
    if (!h || window.innerWidth >= 760) return;
    var col = h.closest('[data-footer-col]');
    if (col) { var open = col.classList.toggle('is-open'); h.setAttribute('aria-expanded', open); }
  });

  /* Live "favorited" counter (optional social proof) */
  $$('[data-fav-live]').forEach(function (el) {
    var c = el.querySelector('[data-fav-count]'); if (!c) return;
    setInterval(function () {
      if (document.hidden) return;
      if (Math.random() < 0.45) {
        var n = parseInt((c.textContent || '').replace(/\D/g, ''), 10) || 0;
        c.textContent = n + 1;
        c.animate([{ opacity: .35, transform: 'translateY(-2px)' }, { opacity: 1, transform: 'none' }], { duration: 450, easing: 'ease-out' });
      }
    }, 9000);
  });

  (function initWishlist() {
    var KEY = 'myk_wishlist';
    function get() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
    function set(v) { localStorage.setItem(KEY, JSON.stringify(v)); }
    function sync() {
      var list = get();
      $$('[data-wish]').forEach(function (b) {
        var card = b.closest('[data-product-id]'); if (!card) return;
        b.classList.toggle('is-active', list.indexOf(card.getAttribute('data-product-id')) > -1);
      });
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-wish]'); if (!b) return;
      e.preventDefault();
      var card = b.closest('[data-product-id]'); if (!card) return;
      var id = card.getAttribute('data-product-id'); var list = get(); var i = list.indexOf(id);
      if (i > -1) { list.splice(i, 1); b.classList.remove('is-active'); } else { list.push(id); b.classList.add('is-active'); toast('Adicionado aos favoritos'); }
      set(list);
    });
    sync();
  })();

  /* Shop the look markers (tap to open on mobile) */
  document.addEventListener('click', function (e) {
    var m = e.target.closest('[data-marker] .dot-marker__btn');
    if (m) { var marker = m.closest('[data-marker]'); $$('[data-marker]').forEach(function (x) { if (x !== marker) x.classList.remove('is-open'); }); marker.classList.toggle('is-open'); }
    else if (!e.target.closest('.dot-marker__pop')) { $$('[data-marker]').forEach(function (x) { x.classList.remove('is-open'); }); }
  });

  /* Re-observe reveals after dynamic inserts */
  document.addEventListener('shopify:section:load', function () {
    if (window.__mykRevealObserver) $$('[data-reveal]:not(.is-in)').forEach(function (el) { window.__mykRevealObserver.observe(el); });
  });

})();